import axios from "axios";

class AxiosClass {
  service: any;

  constructor() {
    let service = axios.create({
      headers: {
        Authorization:
          "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJZZWlzbiIsImp0aSI6ImNmODk2MDY0LWQ3MjgtNDQzOS04OTcxLWZjNzQ3YjBiODczZiIsImh0dHA6Ly9zY2hlbWFzLm1pY3Jvc29mdC5jb20vd3MvMjAwOC8wNi9pZGVudGl0eS9jbGFpbXMvcm9sZSI6IkFkbWluIiwiZXhwIjoxNjc5NjYyNzc3fQ.Zuun1V2HJXAk5B_ZnAS9-AQSWQ4_pWfzqeisCLNrxkQ"
      }
    });
    service.interceptors.response.use(this.handleSuccess, this.handleError);
    this.service = service;
  }

  handleSuccess(response: any) {
    return response;
  }

  handleError = (error: any) => {
    switch (error.response.status) {
      case 401:
        //this.redirectTo(document, '/')
        break;
      case 404:
        //this.redirectTo(document, '/404')
        break;
      default:
        //this.redirectTo(document, '/500')
        break;
    }
    return Promise.reject(error);
  };

  redirectTo = (document: any, path: any) => {
    document.location = path;
  };

  get(path: any, callback: any) {
    return this.service
      .get(path)
      .then((response: any) => callback(response.status, response.data));
  }

  getH(path: any, headers: any, callback: any) {
    return this.service
      .get(path, {
        responseType: "blob",
        headers: {
          Accept: "application/pdf"
        }
      })
      .then((response: any) => callback(response.status, response.data));
  }

  delete(path: any, payload: any, callback: any) {
    return this.service
      .request({
        method: "DELETE",
        url: path,
        responseType: "json",
        data: payload
      })
      .then((response: any) => callback(response.status, response.data));
  }

  put(path: any, payload: any, callback: any) {
    return this.service
      .request({
        method: "PUT",
        url: path,
        responseType: "json",
        data: payload
      })
      .then((response: any) => callback(response.status, response.data));
  }

  patch(path: any, payload: any, callback: any) {
    return this.service
      .request({
        method: "PATCH",
        url: path,
        responseType: "json",
        data: payload
      })
      .then((response: any) => callback(response.status, response.data));
  }

  post(path: any, payload: any, callback: any) {
    return this.service
      .request({
        method: "POST",
        url: path,
        responseType: "json",
        data: payload
      })
      .then((response: any) => callback(response.status, response.data));
  }
}

// La URL se obtiene automáticamente de las variables de entorno:
// - npm start → usa .env.development (localhost)
// - npm run build → usa .env.production (Azure)
export const EnpointsUrlBase = process.env.REACT_APP_API_URL || "https://localhost:7021/api";

export default new AxiosClass();
